import { render, staticRenderFns } from "./TabelaSubmetidasAprovacao.vue?vue&type=template&id=31dca892&scoped=true&"
import script from "./TabelaSubmetidasAprovacao.vue?vue&type=script&lang=js&"
export * from "./TabelaSubmetidasAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaSubmetidasAprovacao.vue?vue&type=style&index=0&id=31dca892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dca892",
  null
  
)

export default component.exports